import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, { formatDateTimeWithoutSec, formattedDate, getCurrentDateTime } from "../../../../Common/helper/helpar";
import MSWManagementTertiaryCollectionStore from "./store/MSWManagementTertiaryCollectionStore";

export const MSWManagementTertiaryVehiclesOnRoad = () => {
  const navigate = useNavigate();
  const isProd = isGHMC();

  const {
    fetchMSWManagementTertiaryCollectionReport,
    loading,
    MSWManagementTertiaryCollectionReportData,
  } = MSWManagementTertiaryCollectionStore();

  /* ================= PAGINATION STATE ================= */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  /* ================= TOTAL CALC ================= */
  const totals = MSWManagementTertiaryCollectionReportData?.reduce(
    (acc, item) => {
      acc.planned += Number(item.plannedVehicles || 0);
      acc.deployed += Number(item.deployedVehicles || 0);
      acc.attended += Number(item.attended || 0);
      acc.performanceAchieved  += Number(item.performanceAchieved || 0);
      return acc;
    },
    { planned: 0, deployed: 0, attended: 0 , performanceAchieved: 0 }
  );

  const storedFilters = localStorage.getItem(
    "mswTertiaryVehiclesFilters"
  );
  const parsedFilters = storedFilters
    ? JSON.parse(storedFilters)
    : null;

  const headerStyles = {
    fontWeight: 600,
    textAlign: "center",
    border: "1px solid #fff",
    color: "#fff",
    backgroundColor: isProd ? "#0d5da5" : "#EC1117",
  };

  const cellStyles = {
    textAlign: "center",
    border: "1px solid #fff",
    fontSize: "14px",
  };

  

  /* ================= HANDLERS ================= */
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const currentDate = getCurrentDateTime();


  return (
    <div className="card mt-1">
      <div className="top-header">
        <span>MSW Management Vehicles On The Road - Tertiary Collection   {parsedFilters?.FromDate && parsedFilters?.ToDate
                    ? ` (${formattedDate(parsedFilters.FromDate)} to ${formattedDate(parsedFilters.ToDate)})`
                    : ""} at ({formatDateTimeWithoutSec(currentDate)})</span>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Paper sx={{ border: "1px solid #ccc" }}>
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader>
              {/* ================= HEADER ================= */}
              <TableHead>
                <TableRow>
                  <TableCell sx={headerStyles}>S.No</TableCell>
                  <TableCell sx={headerStyles}>Date</TableCell>
                  <TableCell sx={headerStyles}>
                    Total Number of Vehicles <br /> Planned For Deployment
                  </TableCell>
                  <TableCell sx={headerStyles}>
                    Total Number of <br />Vehicles Deployed
                  </TableCell>
                  {/* <TableCell sx={headerStyles}>
                    Bins / GVPs <br /> Attended
                  </TableCell> */}
                  <TableCell sx={headerStyles}>
                    Performance Achieved
                  </TableCell>
                </TableRow>
              </TableHead>

              {/* ================= BODY ================= */}
              <TableBody>
                {MSWManagementTertiaryCollectionReportData
                  ?.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: isProd
                          ? index % 2 === 0
                            ? "#8fc9ff"
                            : "#aed8ff"
                          : index % 2 === 0
                          ? "#F8CCCD"
                          : "#ffeded",
                      }}
                    >
                      <TableCell sx={cellStyles}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>

                      <TableCell sx={cellStyles}>
                        <span
                          style={{ color: "blue", cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              "/msw-management-tertiary-vehicles-inner-report",
                              { state: { date: row.date } }
                            )
                          }
                        >
                          {formattedDate(row.date)}
                        </span>
                      </TableCell>

                      <TableCell sx={cellStyles}>
                        {row.plannedVehicles}
                      </TableCell>
                      <TableCell sx={cellStyles}>
                        {row.deployedVehicles || 0}
                      </TableCell>
                      {/* <TableCell sx={cellStyles}>
                        {row.attended || 0}
                      </TableCell> */}
                      <TableCell sx={cellStyles}>
                        {row.performanceAchieved}
                      </TableCell>
                    </TableRow>
                  ))}

                {/* ================= TOTAL ROW ================= */}
                {MSWManagementTertiaryCollectionReportData?.length > 0 && (
                  <TableRow 
                      sx={{
                        backgroundColor: isProd
                          ? "#8fc9ff" 
                          : "#ffeded",
                      }}>
                    <TableCell
                      sx={cellStyles}
                      colSpan={2}
                    >
                      Total
                    </TableCell>
                    <TableCell 
                      sx={cellStyles}>
                      {totals.planned}
                    </TableCell>
                    <TableCell 
                      sx={cellStyles}>
                      {totals.deployed}
                    </TableCell>
                    {/* <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                      {totals.attended}
                    </TableCell> */}
                    <TableCell 
                      sx={cellStyles}>
                      {/* {totals.performanceAchieved} */}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
            component="div"
            count={MSWManagementTertiaryCollectionReportData?.length || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[500, 1000, 2000]}
          />
          </TableContainer>

          {/* ================= PAGINATION ================= */}
        
        </Paper>
      )}
    </div>
  );
};
